var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExperienceActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7202 1.55746L7.85156 7.42706L1.36411 8.35384C0.216669 8.53037 -0.224654 9.9426 0.61386 10.7811L5.24775 15.3267L4.14445 21.7259C3.96792 22.8734 5.20362 23.756 6.21866 23.2264L12 20.1813L17.7372 23.2264C18.7522 23.756 19.9879 22.8734 19.8114 21.7259L18.7081 15.3267L23.342 10.7811C24.1805 9.9426 23.7392 8.53037 22.5918 8.35384L16.1484 7.42706L13.2357 1.55746C12.7502 0.542418 11.2497 0.498286 10.7202 1.55746Z",
    fill: "#FFC803"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceActive);
export default __webpack_public_path__ + "static/media/experienceActive.80b93c83376672123544c8653c97cf1a.svg";
export { ForwardRef as ReactComponent };